import { formatInstant } from './dashboardFormat';

/** When the figures on the page were generated, in the company's time zone. A real <time> element, so assistive technology and tests can read the instant. */
export function FreshnessIndicator({ generatedAtUtc, timeZoneId }: { generatedAtUtc: string; timeZoneId: string }) {
  return (
    <span className="ed-freshness">
      Data as of <time dateTime={generatedAtUtc}>{formatInstant(generatedAtUtc, timeZoneId)}</time>
    </span>
  );
}
